/**
 * "Наш аккаунт" cell of the clients list (KAN-618): OUR Telegram account that
 * talks to the client. Shared by the desktop table and the mobile card.
 */
import { SenderAccountIdentity } from '@/components/messages/SenderAccountIdentity';
import type { Client } from '@/types/client';

interface ClientSenderAccountProps {
  client: Client;
  /** data-testid of the rendered element (differs for table / mobile card). */
  testId: string;
}

export function ClientSenderAccount({
  client,
  testId,
}: ClientSenderAccountProps): JSX.Element {
  return (
    <SenderAccountIdentity
      account={client.sender_account}
      testId={testId}
      fallback={
        <span data-testid={testId} className="text-gray-400 text-sm">
          -
        </span>
      }
    />
  );
}
